import React, { useState } from 'react';
import { classnames } from 'Utils/classnames/classnames.utils';
import { t } from 'Src/i18n';
import { Button } from 'Components/frameworks/button/Button';
import { useTracking } from 'Tracking/tracking-api/useTracking';
import { BE_GA_DEFAULT_PAYLOAD } from 'Views/booking/constants';
type Props = {
  proposal: Proposal;
};
export const SellerCommission = ({ proposal }: Props) => {
  const [shownCommission, setShownCommission] = useState(false);
  const track = useTracking({ ...BE_GA_DEFAULT_PAYLOAD, actionGA: 'confirmationDucroire' });

  if (!proposal.sellerCommission || proposal.households.length > 1) {
    return null;
  }

  return (
    <div className="border-t border-grey p-10">
      {shownCommission && (
        <div className="flex justify-between">
          <div>
            <div className="text-14 text-black">{t('booking.partners.fees.feesLabel')}</div>
            <div className="text-12 text-mediumGrey">
              {t('booking.partners.fees.nonBindingInfo')}
            </div>
          </div>
          <div className="font-bold text-saffron">{proposal.sellerCommission.formattedValue}</div>
        </div>
      )}
      <Button
        className={classnames('w-full text-14 text-saffron underline', {
          'mt-10': shownCommission,
        })}
        onClick={() => {
          !shownCommission &&
            track({
              labelGA: 'SeeCommision',
              categoryGA: 'confirmationDucroire',
            });
          setShownCommission((shownCommissionState) => !shownCommissionState);
        }}
        theme="link"
      >
        {t(
          shownCommission
            ? 'booking.partners.fees.hideLabel'
            : 'booking.partners.fees.showMoreLabel',
        )}
      </Button>
    </div>
  );
};
